import { Component, OnInit } from '@angular/core';
import {TreeViewComponent} from '@shared/components/abstract-component/tree-view.abstract';
import {MenuFlatNode, MenuNode} from '@modules/administration/menus/interfaces/menu.model';
import {MenuType, MenuTypes} from '@modules/administration/menus/menu.constant';
import {RoleTypes} from '@modules/administration/administration.const';
import {Mode} from '@shared/enums/mode.enum';
import {MenuService} from '@modules/administration/menus/services/menu.service';
import {NzModalService} from 'ng-zorro-antd/modal';
import {SelectionModel} from "@angular/cdk/collections";
import * as _ from 'lodash';
import {BaseResponse} from '@core/models/base-response.model';
import {MESSAGE_CODE} from '@shared/constants/message-code.constant';
import {ConfigMenuComponent} from '@modules/administration/menus/components/config-menu/config-menu.component';
import {NotificationService} from '@shared/services/notification.service';
import {IdService} from '@core/service/uuid.service';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrls: ['./menu-list.component.css']
})
export class MenuListComponent extends TreeViewComponent<MenuNode, MenuFlatNode> implements OnInit {
  readonly MODE = Mode;
  readonly MENU_TYPES = MenuTypes;
  ROLE_TYPES = RoleTypes;
  private searchTerm$ = new Subject<string>();


  filterMenus: MenuNode[] = [];
  menus: MenuNode[] = [];
  searchText: string = "";

  isSpinning: boolean = false;
  isExpandAll: boolean = false;

  selectedMenu = new SelectionModel<MenuFlatNode>(false);

  menuTypeSelected: number = MenuType.LEFT_SIDEBAR;

  constructor(private menuService: MenuService,
              private modalService: NzModalService,
              private notiService: NotificationService,
              private idService: IdService,
  ) {
    super([], false);
    this.searchTerm$
      .pipe(debounceTime(500))
      .subscribe((term) => {
        this.getList()
      });
  }

  ngOnInit(): void {
    this.getList();
  }

  getList(reload: boolean = false, key?: any) {
    if (reload) this.searchText = null;
    this.isSpinning = true;
    this.menuService.getListByTree(this.searchText, this.menuTypeSelected).subscribe((res: BaseResponse<any, any>) => {
      if (res && res.messageCode === MESSAGE_CODE.SUCCESS) {
        this.filterMenus = res.data;
        this.dataSource.setData(this.filterMenus);

        if (!this.searchText || this.searchText.trim() === "")
          this.menus = _.cloneDeep(this.filterMenus);
        if (key) {
          const selectNode = this.treeControl.dataNodes.find(value => value.key == key);
          this.selectedMenu.select(selectNode);
          this.treeControl.expand(selectNode);
        } else this.selectedMenu.clear();
      }
      this.isSpinning = false;
    }, error => this.isSpinning = false)
  }

  hasChild = (_: number, node: MenuFlatNode): boolean => node.expandable;

  configMenu() {
    const modal = this.modalService.create(
      {
        nzWidth: window.innerWidth > 767 ? window.innerWidth / 1.5 > 1000 ? 1000 : window.innerWidth / 1.5 : window.innerWidth,
        nzTitle: 'Thêm mới Menu',
        nzContent: ConfigMenuComponent,
        nzComponentParams: {
          mode: Mode.ADD,
          menus: this.menus,
          menuType: this.menuTypeSelected
        },
        nzFooter: null
      }
    )
    modal.afterClose.subscribe(result => {
      if (result) this.getList(result.refresh);
    })
  }

  showDeleteConfirm(): void {
    if (!this.selectedMenu.selected[0]) {
      this.notiService.warning('Chưa chọn Menu muốn xóa.');
      return;
    }
    this.modalService.confirm({
      nzTitle: "Xóa Menu đã chọn",
      nzContent: "Xóa Menu và toàn bộ các menu liên quan. Bạn có chắc chắn xóa ?",
      nzOnOk: () => this.selectedMenu.selected[0] ? this.deleteById() : this.notiService.warning('Chưa chọn Menu muốn xóa.')
    });
  }

  deleteById() {
    this.menuService.deleteMenu(Number(this.selectedMenu.selected[0].key)).subscribe(res => {
      if (res) {
        this.getList(true);
        this.selectedMenu = new SelectionModel<MenuFlatNode>(false);
        this.notiService.success('Xóa Menu thành công.');
      } else {
        this.notiService.error('Xóa Menu thất bại.');
      }
    }, (error) => {
      this.notiService.error('Xóa Menu thất bại.');
    });
  }

  doAction(action: string) {
    switch (action) {
      case "ADD":
        this.configMenu();
        break;
      case "DELETE":
        this.showDeleteConfirm();
        break;
      case "EXPAND_COLLAPSE_ALL":
        this.isExpandAll = !this.isExpandAll;
        this.isExpandAll ? this.treeControl.expandAll() : this.treeControl.collapseAll();
        break;
      default:
        break;
    }
  }

  removeAssignRole(role:string) {
    this.menuService.unOrAssignRole(Number(this.selectedMenu.selected[0].key), role).subscribe(res => {
      if (res) {
        this.selectedMenu.selected[0].data.roles = res.data.roles;
        this.notiService.success('Thành công.');
      } else {
        this.notiService.error('Không thể thực hiện');
      }
    }, (error) => {
      this.notiService.error('Không thể thực hiện.');
    });
  }

  checkExistRole(value: any, selectedMenu: SelectionModel<MenuFlatNode>) {
    return selectedMenu.selected[0].data.roles.includes(value);
  }
  public handleInput(term: any): void {
    this.searchTerm$.next(term);
  }
}
